module.exports = __webpack_public_path__ + "image-0ffe1ae23372.png";